module.exports = __webpack_public_path__ + "static/media/za.c5e7b3a3.svg";